module.exports = __webpack_public_path__ + "static/vision42.6c40ed51.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/vision42.png
// module id = 439
// module chunks = 246384609461072